




































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class MailLayout extends Vue {
  get activeMenu() {
    return this.$route.path;
  }

  handleMenuSelect(index: string) {
    if (index !== this.$route.path) {
      this.$router.push(index);
    }
  }

  hasPerm(name: string) {
    return this.$store.getters['perms/has'](name);
  }

  get hasMailingListPerm() {
    return this.hasPerm('mailing-list-admin');
  }

  get hasMailQueryPerm() {
    return this.hasPerm('mail-query-admin');
  }

  get hasImportEmailPerm() {
    return this.hasPerm('import-email');
  }
}
